import { render, staticRenderFns } from "./UgiPopup.vue?vue&type=template&id=361061ac&scoped=true&"
import script from "./UgiPopup.vue?vue&type=script&lang=js&"
export * from "./UgiPopup.vue?vue&type=script&lang=js&"
import style0 from "./UgiPopup.vue?vue&type=style&index=0&id=361061ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361061ac",
  null
  
)

export default component.exports